module.exports = __webpack_public_path__ + "img/profile--arrow.6c1d9809.svg";